import { Column, Row, Space, StarFilled } from 'farmhub-ui-core';
import { css } from 'styled-components';

import { NameText, Table, WrapperChildTable } from 'components';
import { theme } from 'styled';

import ProductPricePolicyTable from '../ProductPricePolicyTable';

interface PricePolicyStepProps {
  pricePolicies: any[];
  selectedPricePolicyID: string;
  setSelectedPricePolicyID: (e: string) => void;
}

const PricePolicyStepDesktop = ({
  pricePolicies,
  selectedPricePolicyID,
  setSelectedPricePolicyID,
}: PricePolicyStepProps): JSX.Element => {
  const columns = [
    {
      key: 'name',
      render: (data: any) => (
        <Row width="100%">
          <NameText lineNumber={1} title={data.name}>
            {data.name}{' '}
          </NameText>
          {data.isDefault && (
            <Row styles={{ maxWidth: '70px' }}>
              <NameText color="main"> (Mặc định)</NameText>{' '}
            </Row>
          )}
          <Space width={4} />
          <Row width="8px">
            <NameText color="price"> {data.rating}</NameText>
          </Row>

          <StarFilled
            style={{
              color: theme.colors.startFill,
              paddingTop: 1,
            }}
          />
        </Row>
      ),
    },
  ];

  return (
    <Column width="472px">
      <Space height={36} />
      <Table
        columns={columns}
        dataSource={pricePolicies}
        expandable={{
          // expandRowByClick: true,
          expandIconColumnIndex: 3,
          expandedRowRender: (record: any) => (
            <WrapperChildTable>
              <ProductPricePolicyTable record={record} />
            </WrapperChildTable>
          ),
        }}
        locale={{ emptyText: 'Không tìm thấy dữ liệu' }}
        rowKey="id"
        rowSelection={{
          type: 'radio',
          selectedRowKeys: [selectedPricePolicyID],
          onChange: (keys: any[], rows) => setSelectedPricePolicyID(keys[0]),
        }}
        showHeader={false}
        styles={TableStyles}
      />

      <Space height={24} />
    </Column>
  );
};

export default PricePolicyStepDesktop;

const TableStyles = css`
  .ant-table-cell {
  }
  .ant-pagination {
    margin-top: 16px;
    margin-bottom: 0;
    > li {
      min-width: 23px;
      height: 23px;
      line-height: 22px;
      .ant-select > .ant-select-selector {
        min-width: 22px;
        height: 23px;
        line-height: 22px;
        > .ant-select-selection-item {
          line-height: 22px;
        }
      }
      .ant-select > .ant-select-arrow {
        margin-top: -4px;
      }
    }
  }
`;
